/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'search': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: `<defs><clipPath id="svgicon_search_a"><path pid="0" d="M0 0h18v18H0z"/></clipPath></defs><g _fill="none" _stroke="currentColor" clip-path="url(#svgicon_search_a)"><g transform="translate(3.824)"><ellipse pid="1" cx="7.088" cy="7.185" rx="7.088" ry="7.185" _stroke="none"/><ellipse pid="2" cx="7.088" cy="7.185" rx="6.588" ry="6.685"/></g><path pid="3" d="M6.21 11.711L.499 17.5"/></g>`
  }
})
/* tslint:enable */
